import { PRIVATE_ADMIN } from 'Shared/Routing/Application/Constants/PathsConstant';

export const PRIVATE_ADMIN_EXTRA_CONFIG = PRIVATE_ADMIN + '/extra-config';
export const PRIVATE_ADMIN_EXTRA_CONFIG_FORM = PRIVATE_ADMIN_EXTRA_CONFIG + '/form';
